/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useHistory } from "react-router";
import PageHeader from '../../../components/PageHeader';
import queryString from "query-string";
import CollaborationSetting from '../../../components/TaxConsulting/CollaborationSetting';
import TaxConsultingCollaborations from './TaxConsultingCollaborations';
import { isEmpty } from '../../../utils/lodashExtend';

const TaxConsultingCollaboration = (props) => {
  const history = useHistory();
  const { company } = useSelector(
    (store) => ({
      company: store.Profile.company,
    }),
    shallowEqual
  );

  const [title, setTitle] = useState('');

  const [activeTab, setActiveTab] = useState();

  const _setActiveTab = (value) => {
    history.push(`/tax-portal/tax-consulting-collaboration?tab=${value}`);
  };

  const tabList = [
    {
      label: "받은 요청 관리",
      action: _setActiveTab,
      value: "received",
    },
    {
      label: "내 요청 관리",
      action: _setActiveTab,
      value: "request",
    },
    {
      label: "협업 가능 여부",
      action: _setActiveTab,
      value: "setting",
    },

  ];

  useEffect(() => {
    const query = queryString.parse(history.location.search);
    setActiveTab(query.tab || tabList[0].value);
  }, [history.location]);

  useEffect(() => {
    if (company) {
      const _company = company?.taxCompany || company;
      let _title = "";

      switch (activeTab) {
        case 'setting':
          _title = `${_company.name} 컨설팅 협업 가능 여부`;
          break;
        default:
          _title = `컨설팅 협업 요청`;
          break;
      }
      setTitle(_title);
    }

  }, [activeTab, company]);

  return (
    <>
      <PageHeader
        title={title}
        activeTab={activeTab}
        tabList={tabList}
      />

      {activeTab === "setting"
        ? <CollaborationSetting />
        : !isEmpty(activeTab)
          ? <TaxConsultingCollaborations type={activeTab} />
          : <></>
      }
    </>
  );
};

export default TaxConsultingCollaboration;